import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store';

import { SystemProps } from './system.types';

const initialState: SystemProps = {
  startLocation: null,
  wasLoggedOutManually: false
};

const systemSlice = createSlice({
  initialState,
  name: 'system',
  reducers: {
    setStartLocation: (state, action: PayloadAction<SystemProps['startLocation']>) => {
      state.startLocation = action.payload;
    },
    setWasLoggedOutManually: (state, action: PayloadAction<boolean>) => {
      state.wasLoggedOutManually = action.payload;
    }
  }
});

export const selectSystem = (state: RootState) => state.system;

export const { setStartLocation, setWasLoggedOutManually } = systemSlice.actions;

export default systemSlice.reducer;
